import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { adm } from "../../lib/adminApi";
import { Field, inp } from "./ui";

/* Multi-select store products picker. `field` = which product property is stored (lookupKey | id). */
export default function ProductMultiPicker({ label, value, onChange, field = "lookupKey", filter, testid }) {
  const selected = Array.isArray(value) ? value : [];
  const [products, setProducts] = useState([]);
  useEffect(() => { adm.list("products").then(setProducts).catch(() => {}); }, []);

  const byKey = Object.fromEntries(products.map((p) => [p[field], p]));
  const available = products.filter((p) => !selected.includes(p[field]) && (!filter || filter(p)));

  return (
    <Field label={label} className="md:col-span-2">
      <div className="flex flex-wrap gap-2 mb-2" data-testid={testid}>
        {selected.length === 0 && (
          <span className="font-mono text-[9px] text-white/30 border border-dashed border-white/15 px-3 py-2">NONE SELECTED</span>
        )}
        {selected.map((k) => (
          <span key={k} className="inline-flex items-center gap-2 border border-gold/30 bg-gold/5 px-3 py-1.5"
            data-testid={`${testid}-chip-${k}`}>
            <span className="text-white/85 text-xs">{byKey[k]?.name || k}</span>
            <button onClick={() => onChange(selected.filter((x) => x !== k))} aria-label={`Remove ${k}`}
              data-testid={`${testid}-remove-${k}`} className="text-white/40 hover:text-red-400"><X size={12} /></button>
          </span>
        ))}
      </div>
      <select value="" onChange={(e) => e.target.value && onChange([...selected, e.target.value])}
        data-testid={`${testid}-select`} className={`${inp} bg-[#0d0d0d]`}>
        <option value="">+ ADD PRODUCT…</option>
        {available.map((p) => (
          <option key={p.id} value={p[field]}>
            {`${p.name} ${p.isPlaceholder ? "· PLACEHOLDER " : ""}(${p.lookupKey})`}
          </option>
        ))}
      </select>
    </Field>
  );
}
